// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Products_productsWrapper__58JH8 {
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  direction: rtl;
  background: #f8f9fa;
}

.Products_pageTitle__U8pCs {
  text-align: center;
  margin-bottom: 40px;
  font-size: 28px;
  color: #1a202c;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* Year Navigation - Matching speeches/audio style */
.Products_yearNavigation__Fzk65 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 40px;
  padding: 15px;
  margin-top: 50px;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);
}

.Products_navButton__Pt5sN {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.3s ease;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 75px;
  backdrop-filter: blur(10px);
}

.Products_navButton__Pt5sN .Products_arrow__KFr\\+R {
  font-size: 20px;
  font-weight: bold;
}

.Products_navButton__Pt5sN:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);
}

.Products_navButton__Pt5sN:disabled {
  background: rgba(255, 255, 255, 0.1);
  cursor: not-allowed;
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.2);
  transform: none;
  box-shadow: none;
}

.Products_yearButtons__hy59b {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.15);
  padding: 6px;
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.Products_yearBtn__4jycD {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 8px 14px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  width: 55px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
}

.Products_yearBtn__4jycD:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-1px);
}

.Products_activeYear__fjaMn {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #1a5f3f !important;
  border-color: rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3) !important;
  font-weight: 700 !important;
}

.Products_yearDots__zEzzF {
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  font-weight: bold;
  padding: 0 10px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Products Grid Layout - 3 columns */
.Products_productsGrid__dVa46 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 40px;
}

/* Responsive */
@media (max-width: 1024px) {
  .Products_productsGrid__dVa46 {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .Products_productsWrapper__58JH8 {
    padding: 15px;
  }

  .Products_productsGrid__dVa46 {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .Products_yearNavigation__Fzk65 {
    flex-wrap: wrap;
    gap: 10px;
    width: 1005;
  }

  .Products_yearBtn__4jycD {
    width: 46px;
  }

  .Products_yearButtons__hy59b {
    order: -1;
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .Products_productsGrid__dVa46 {
    grid-template-columns: 1fr;
  }

  .Products_pageTitle__U8pCs {
    font-size: 24px;
  }

  .Products_yearBtn__4jycD {
    width: 35PX;
  }
}

.Products_productCard__ajBas {
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  cursor: pointer;
  height: 250px;
  text-decoration: none;
  color: inherit;
}

.Products_productCard__ajBas::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease;
}

.Products_productCard__ajBas:hover {
  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.15);
  transform: translateY(-4px);
}

.Products_productCard__ajBas:hover::before {
  transform: scaleX(1);
}

.Products_productImageContainer__YR\\+or {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.Products_productImage__vd6Fl {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.Products_productCard__ajBas:hover .Products_productImage__vd6Fl {
  transform: scale(1.05);
}

.Products_productOverlay__LZwOB {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(26, 95, 63, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
}

.Products_productCard__ajBas:hover .Products_productOverlay__LZwOB {
  opacity: 1;
}

.Products_productIcon__mI2ZK {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #1a5f3f;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.Products_productCard__ajBas:hover .Products_productIcon__mI2ZK {
  transform: scale(1.1);
  background: #ffffff;
}

.Products_productContent__qjdgt {
  padding: 16px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.Products_productTitle__LJ1jh {
  margin: 0 0 8px 0;
  font-size: 15px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.3;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.Products_productMeta__Pp2bW {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 11px;
  margin-top: auto;
}

.Products_productDate__4FQr2 {
  color: #1a5f3f;
  font-weight: 600;
  background: rgba(26, 95, 63, 0.1);
  padding: 2px 6px;
  border-radius: 8px;
}

.Products_productAuthor__fyF8K {
  color: #64748b;
  font-weight: 500;
}

.Products_productMeta__Pp2bW::after {
  content: '•';
  color: #cbd5e1;
  font-weight: bold;
}

.Products_loadingIndicator__jKG9w {
  text-align: center;
  padding: 60px;
  color: #1a5f3f;
  font-size: 18px;
  font-weight: 600;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 16px;
  margin: 20px 0;
  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.1);
}

.Products_noProductsMessage__ROaVP {
  text-align: center;
  padding: 60px;
  color: #64748b;
  font-size: 16px;
  background: linear-gradient(135deg, #f1f5f9 0%, #f8fafc 100%);
  border-radius: 16px;
  margin: 20px 0;
  border: 2px dashed #cbd5e1;
}

.Products_loadMoreSection__XbmIi {
  text-align: center;
  margin-top: 40px;
  padding: 30px;
}

.Products_loadMoreBtn__\\+ZrNM {
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  color: white;
  border: none;
  border-radius: 14px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(26, 95, 63, 0.3);
  margin-bottom: 16px;
}

.Products_loadMoreBtn__\\+ZrNM:hover {
  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.4);
}

.Products_productCount__VrSKd {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  background: rgba(26, 95, 63, 0.1);
  padding: 8px 16px;
  border-radius: 20px;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Main pages/Products.module.css"],"names":[],"mappings":";AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;EAC/B,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,iDAAiD;EACjD,0DAA0D;EAC1D,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;IACT,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":["\r\n.productsWrapper {\r\n  width: 80%;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  direction: rtl;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.pageTitle {\r\n  text-align: center;\r\n  margin-bottom: 40px;\r\n  font-size: 28px;\r\n  color: #1a202c;\r\n  font-weight: 700;\r\n  text-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n/* Year Navigation - Matching speeches/audio style */\r\n.yearNavigation {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  margin-bottom: 40px;\r\n  padding: 15px;\r\n  margin-top: 50px;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  border-radius: 16px;\r\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);\r\n}\r\n\r\n.navButton {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n  border: 2px solid rgba(255, 255, 255, 0.3);\r\n  border-radius: 20px;\r\n  padding: 10px 16px;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n  height: 44px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  min-width: 75px;\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.navButton .arrow {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n}\r\n\r\n.navButton:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.3);\r\n  border-color: rgba(255, 255, 255, 0.5);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.navButton:disabled {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  cursor: not-allowed;\r\n  color: rgba(255, 255, 255, 0.5);\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n  transform: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.yearButtons {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: rgba(255, 255, 255, 0.15);\r\n  padding: 6px;\r\n  border-radius: 16px;\r\n  backdrop-filter: blur(10px);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.yearBtn {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: white;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 12px;\r\n  padding: 8px 14px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n  width: 55px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n.yearBtn:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-color: rgba(255, 255, 255, 0.4);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.activeYear {\r\n  background: rgba(255, 255, 255, 0.9) !important;\r\n  color: #1a5f3f !important;\r\n  border-color: rgba(255, 255, 255, 0.9) !important;\r\n  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3) !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.yearDots {\r\n  color: rgba(255, 255, 255, 0.7);\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  padding: 0 10px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Products Grid Layout - 3 columns */\r\n.productsGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 24px;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 1024px) {\r\n  .productsGrid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 20px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .productsWrapper {\r\n    padding: 15px;\r\n  }\r\n\r\n  .productsGrid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 16px;\r\n  }\r\n\r\n  .yearNavigation {\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n    width: 1005;\r\n  }\r\n\r\n  .yearBtn {\r\n    width: 46px;\r\n  }\r\n\r\n  .yearButtons {\r\n    order: -1;\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .productsGrid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .pageTitle {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .yearBtn {\r\n    width: 35PX;\r\n  }\r\n}\r\n\r\n.productCard {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\r\n  border-radius: 16px;\r\n  transition: all 0.3s ease;\r\n  border: 1px solid #e2e8f0;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n  position: relative;\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n  height: 250px;\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\n.productCard::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);\r\n  transform: scaleX(0);\r\n  transform-origin: center;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.productCard:hover {\r\n  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.15);\r\n  transform: translateY(-4px);\r\n}\r\n\r\n.productCard:hover::before {\r\n  transform: scaleX(1);\r\n}\r\n\r\n.productImageContainer {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 180px;\r\n  overflow: hidden;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\r\n}\r\n\r\n.productImage {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.productCard:hover .productImage {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.productOverlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(26, 95, 63, 0.8);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  opacity: 0;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.productCard:hover .productOverlay {\r\n  opacity: 1;\r\n}\r\n\r\n.productIcon {\r\n  width: 60px;\r\n  height: 60px;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 24px;\r\n  color: #1a5f3f;\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.productCard:hover .productIcon {\r\n  transform: scale(1.1);\r\n  background: #ffffff;\r\n}\r\n\r\n.productContent {\r\n  padding: 16px;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n\r\n.productTitle {\r\n  margin: 0 0 8px 0;\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: #1a202c;\r\n  line-height: 1.3;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.productMeta {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  font-size: 11px;\r\n  margin-top: auto;\r\n}\r\n\r\n.productDate {\r\n  color: #1a5f3f;\r\n  font-weight: 600;\r\n  background: rgba(26, 95, 63, 0.1);\r\n  padding: 2px 6px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.productAuthor {\r\n  color: #64748b;\r\n  font-weight: 500;\r\n}\r\n\r\n.productMeta::after {\r\n  content: '•';\r\n  color: #cbd5e1;\r\n  font-weight: bold;\r\n}\r\n\r\n.loadingIndicator {\r\n  text-align: center;\r\n  padding: 60px;\r\n  color: #1a5f3f;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\r\n  border-radius: 16px;\r\n  margin: 20px 0;\r\n  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.1);\r\n}\r\n\r\n.noProductsMessage {\r\n  text-align: center;\r\n  padding: 60px;\r\n  color: #64748b;\r\n  font-size: 16px;\r\n  background: linear-gradient(135deg, #f1f5f9 0%, #f8fafc 100%);\r\n  border-radius: 16px;\r\n  margin: 20px 0;\r\n  border: 2px dashed #cbd5e1;\r\n}\r\n\r\n.loadMoreSection {\r\n  text-align: center;\r\n  margin-top: 40px;\r\n  padding: 30px;\r\n}\r\n\r\n.loadMoreBtn {\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 14px;\r\n  padding: 16px 32px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 6px 20px rgba(26, 95, 63, 0.3);\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.loadMoreBtn:hover {\r\n  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.4);\r\n}\r\n\r\n.productCount {\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  background: rgba(26, 95, 63, 0.1);\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  display: inline-block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productsWrapper": `Products_productsWrapper__58JH8`,
	"pageTitle": `Products_pageTitle__U8pCs`,
	"yearNavigation": `Products_yearNavigation__Fzk65`,
	"navButton": `Products_navButton__Pt5sN`,
	"arrow": `Products_arrow__KFr+R`,
	"yearButtons": `Products_yearButtons__hy59b`,
	"yearBtn": `Products_yearBtn__4jycD`,
	"activeYear": `Products_activeYear__fjaMn`,
	"yearDots": `Products_yearDots__zEzzF`,
	"productsGrid": `Products_productsGrid__dVa46`,
	"productCard": `Products_productCard__ajBas`,
	"productImageContainer": `Products_productImageContainer__YR+or`,
	"productImage": `Products_productImage__vd6Fl`,
	"productOverlay": `Products_productOverlay__LZwOB`,
	"productIcon": `Products_productIcon__mI2ZK`,
	"productContent": `Products_productContent__qjdgt`,
	"productTitle": `Products_productTitle__LJ1jh`,
	"productMeta": `Products_productMeta__Pp2bW`,
	"productDate": `Products_productDate__4FQr2`,
	"productAuthor": `Products_productAuthor__fyF8K`,
	"loadingIndicator": `Products_loadingIndicator__jKG9w`,
	"noProductsMessage": `Products_noProductsMessage__ROaVP`,
	"loadMoreSection": `Products_loadMoreSection__XbmIi`,
	"loadMoreBtn": `Products_loadMoreBtn__+ZrNM`,
	"productCount": `Products_productCount__VrSKd`
};
export default ___CSS_LOADER_EXPORT___;
